import { render, staticRenderFns } from "./PreviousTrip.vue?vue&type=template&id=80537d3a&scoped=true"
import script from "./PreviousTrip.vue?vue&type=script&lang=js"
export * from "./PreviousTrip.vue?vue&type=script&lang=js"
import style0 from "./PreviousTrip.vue?vue&type=style&index=0&id=80537d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80537d3a",
  null
  
)

export default component.exports